import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = {
  class: "stepper stepper-links d-flex flex-column",
  id: "kt_create_account_stepper",
  ref: "horizontalWizardRef"
}
const _hoisted_4 = { class: "stepper-nav py-5 mt-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "stepper-title" }, " Account Role ", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "stepper-title" }
const _hoisted_8 = { class: "mx-auto mw-600px w-100 pt-15 pb-10" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "svg-icon svg-icon-4 ms-1 me-0" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "indicator-label" }
const _hoisted_14 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_16 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Create ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step1 = _resolveComponent("Step1")!
  const _component_UserCreateFields = _resolveComponent("UserCreateFields")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["stepper-item", _ctx.step == 1 ? 'current' : ''])
          }, _hoisted_6, 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields.steps, (name, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["stepper-item", _ctx.step == index + 2 ? 'current' : '']),
              key: name
            }, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString(name.title), 1)
            ], 2))
          }), 128))
        ])
      ], 512),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.step == 1)
          ? (_openBlock(), _createBlock(_component_Step1, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.step > 1)
          ? (_openBlock(), _createBlock(_component_UserCreateFields, {
              ref: "inputs",
              lastStep: _ctx.isAtLastStep,
              currentStep: _ctx.step,
              onNextStep: _ctx.handleNextStep,
              onCreateUser: _ctx.handleCreate,
              onChangePaymentAccount: _ctx.handleChangePaymentAccount,
              title: _ctx.fields.steps[_ctx.step - 2],
              key: _ctx.key
            }, null, 8, ["lastStep", "currentStep", "onNextStep", "onCreateUser", "onChangePaymentAccount", "title"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex", _ctx.step == 1 ? 'justify-content-end' : 'justify-content-between'])
        }, [
          (_ctx.step > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-lg btn-primary",
                disabled: _ctx.loading,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
              }, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Left-2.svg" })
                ]),
                _hoisted_11
              ], 8, _hoisted_9))
            : _createCommentVNode("", true),
          (_ctx.step >= 1 && !_ctx.isAtLastStep)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-lg btn-primary me-3",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleStepIncrement && _ctx.handleStepIncrement(...args))),
                disabled: _ctx.loading
              }, [
                _createElementVNode("span", _hoisted_13, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                    : _createCommentVNode("", true),
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
                  ])
                ])
              ], 8, _hoisted_12))
            : _createCommentVNode("", true),
          (_ctx.isAtLastStep)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn btn-lg btn-success me-3",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createUser && _ctx.createUser(...args))),
                disabled: _ctx.loading
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                  : _createCommentVNode("", true),
                _hoisted_19
              ], 8, _hoisted_17))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ]))
}